import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormGroup, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';

import { IResponseGetEmpresaById } from 'src/app/services/EmpresaService/empresa.model';

import { FormAgendamentoHandler } from './utils/form-agendamento-handlers';
@Component({
  selector: 'app-cadastro-agendamento',
  templateUrl: './cadastro-agendamento.component.html',
  styleUrls: ['./cadastro-agendamento.component.scss']
})
export class CadastroAgendamentoEmpresaComponent
  extends FormAgendamentoHandler
  implements OnInit, OnDestroy
{
  private hasInitialized = false;
  constructor() {
    super();
    this.form = this._inicializarFormularioStep1();
    this.step2Form = this._inicializarFormularioStep2();
  }

  ngOnInit(): void {
    this.configStepForm();
    const status = this.statusAgendamento();

    const observables = [
      this.getCarga(),
      this.getServico(status),
      this.getMotorista(status),
      this.getPlacaCavalo(status),
      this.getPlacaCarreta(status),
      this.getTransportadora(),
      this.getCliente(),
      this.getDestinatario(),
      this.getJanelas(),
      this.getTipoCarreta()
    ];

    forkJoin(observables).subscribe(() => {
      this.stateForms();
      this.loadStep1Data();
    });

    this.monitorarCamposAgendamento();
    this.obterAcompanhantes();

    if (this.isView) {
      this.step2Form.disable();
    }
  }
  configStepForm() {
    this.subscription$.add(
      this.stepFormService.currentStep$.subscribe(step => {
        this.currentStep = step;
      })
    );

    this.form.valueChanges.subscribe(() => {
      if (this.form.valid) {
        this.stepFormService.saveStepData(1, this.form.getRawValue());
      }
    });
  }

  loadStep1Data(): void {
    const stepData = this.stepFormService.getStepData(1);

    if (stepData && Object.keys(stepData).length > 0) {
      const valueChangesSub = this.form.valueChanges.subscribe();
      valueChangesSub.unsubscribe();

      this.form.patchValue(stepData, { emitEvent: false });

      this.form.valueChanges.subscribe(() => {
        if (this.form.valid) {
          this.stepFormService.saveStepData(1, this.form.getRawValue());
        }
      });
    }

    this.hasInitialized = true;
  }
  private _inicializarFormularioStep1(): FormGroup {
    return this.fb.group({
      FK_SRVC: [0, [Validators.required]],
      DT_AGND: ['', [Validators.required]],
      FK_CMNH: [0],
      FK_MTRT_EPSA: [0, [Validators.required]],
      FK_CAVA: [0, [Validators.required]],
      FK_CRRT_1: [0],
      FK_CRRT_2: [0],
      FK_CRRT_3: [0],
      TX_OBSV_AGND: [''],
      TX_NOTA_FISCAL: [null, [Validators.required]],
      NU_VOLUME: [null, [Validators.required]],
      NU_PESO_TON: [null, [Validators.required]],
      TX_CPF: [''],
      TX_CNH: [''],
      NU_TELE: [''],
      TURNO: [{ value: '', disabled: true }],
      FK_JNLA: [null, [Validators.required]],
      FK_TPTD: [0, [Validators.required]],
      FK_CLNT: [0, [Validators.required]],
      FK_DTNR: [0, [Validators.required]],
      FK_CRGA: [0, [Validators.required]],
      FK_TIPO_CRRT: [0, [Validators.required]]
    });
  }
  private _inicializarFormularioStep2(): FormGroup {
    return this.fb.group({
      ACPN_LIST: this.fb.array([])
    });
  }
  postarDados() {
    this.form.markAllAsTouched();
    this.step2Form.markAllAsTouched();

    if (this.form.invalid) {
      this.swalAlert.showAlert(
        'Atenção',
        'Verifique se todos os campos do primeiro passo foram preenchidos corretamente.',
        'warning'
      );
      this.stepFormService.setCurrentStep(1);
      return;
    }

    const acompanhanteSemNascimento = (
      this.step2Form.get('ACPN_LIST')?.value ?? []
    ).some(
      (a: any) => a.NM_ACPN && a.NM_ACPN.trim() !== '' && !a.DT_NASC
    );

    if (acompanhanteSemNascimento) {
      this.swalAlert.showAlert(
        'Atenção',
        'Informe a data de nascimento de todos os acompanhantes ou remova os acompanhantes sem essa informação.',
        'warning'
      );
      this.stepFormService.setCurrentStep(2);
      return;
    }

    this.isLoading = true;
    // Dados do passo 1 em memória/localStorage podem ficar defasados; o form ao vivo tem prioridade (ex.: FK_JNLA).
    const mergedData = {
      ...this.stepFormService.getMergedData(),
      ...this.form.getRawValue()
    };

    const dtAgndApi = this.dataAgendamentoParaApi(mergedData['DT_AGND']);

    const acompanhantes = (this.step2Form.get('ACPN_LIST')?.value ?? [])
      .filter((a: any) => a.NM_ACPN && a.NM_ACPN.trim() !== '') // Só se tiver nome
      .map((a: any) => ({
        PK_ACPN: a.PK_ACPN ?? null,
        NM_ACPN: a.NM_ACPN ?? '',
        NU_VNCL_MTRT: a.NU_VNCL_MTRT ?? null,
        DT_NASC:
          typeof a.DT_NASC === 'string' && a.DT_NASC.includes('T')
            ? a.DT_NASC.split('T')[0]
            : a.DT_NASC,
        TX_DOC_VNCL: a.TX_DOC_VNCL ?? null
      }));

    const payload = {
      ...mergedData,
      DT_AGND: dtAgndApi,
      FK_CMNH: this.idCaminhao,
      ACPN_LIST: acompanhantes
    };

    if (this.title.includes('Editar')) {
      this.agendamentoService
        .EditarAgendamentoEmpresa(this.idAgendamento, payload)
        .subscribe(
          () => {
            this.router.navigate(['empresa/listagem/agendamento']);
            this.isLoading = false;
            this.stepFormService.reset();
          },
          () => {
            this.isLoading = false;
          }
        );
    } else if (
      this.title.includes('Cadastro') ||
      this.title.includes('Novo Agendamento')
    ) {
      this.agendamentoService
        .CreateAgendamentoEmpresa(payload, this.guid)
        .subscribe(
          response => {
            const queryParams = {
              PK_AGND: response.PK_AGND,
              VL_SRVC: this.valorServico
            };

            const idEmpresa: number = Number(localStorage.getItem('id'));
            let isFaturado = false;

            this.empresaService
              .GetEmpresaById(idEmpresa)
              .subscribe((response: IResponseGetEmpresaById) => {
                isFaturado = Boolean(response.FL_FTRD_EPSA);

                if (!isFaturado) {
                  this.router.navigate(['empresa/pagamento'], {
                    queryParams: queryParams
                  });
                } else {
                  this.router.navigate(['empresa/listagem/agendamento']);
                }

                this.stepFormService.reset();
              });

            this.isLoading = false;
          },
          () => {
            this.isLoading = false;
          }
        );
    }
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  nextStep(): void {
    this.form.markAllAsTouched();

    this.stepFormService.saveStepData(1, this.form.getRawValue());
    this.stepFormService.setCurrentStep(2);
  }
  prevStep(): void {
    this.stepFormService.saveStepData(2, this.step2Form.getRawValue());
    this.stepFormService.setCurrentStep(1);
  }

  onStep1DataChange(data: any) {
    this.stepFormService.saveStepData(1, data);
  }
}
